export const REQUEST_API = {
  getActivityStatus: "/activity/activity-center/feignActivity/inst/activityAll", // 活动基础信息
  openPrize: "/activity/activity-center/feignActivity/inst/openPrize", // 开奖
  getUserInfo: "/activity/activity-center/feignActivity/inst/getUserName", // 用户信息
  checkUserCount: "/activity/activity-center/feignActivity/inst/getluckDrawFrequency", // 用户参与活动次数
  activityGiftSet: "/activity/activity-center/feignActivity/inst/activityOfPrize", // 奖品信息
  getHistory: "/activity/activity-center/feignActivity/inst/userActivityHis", // 用户中奖纪录
  checkUserRule: "/activity/activity-center/feignActivity/inst/checkUserPrize", // 用户参与活动限制
  giftResult: "/activity/activity-center/feignActivity/inst/getTrtb", // 中奖项信息
  getPCImages: "/activity/activity-center/feignActivity/inst/lookActivityPic",
  getLeaderBoard: "/activity/activity-center/feignActivity/inst/getINSTActivityWinnersList",
}



// WEBPACK FOOTER //
// ./src/utils/api.js